import React, { useState } from 'react';
import t from '~t';
import { useSelector, useDispatch } from 'react-redux';
import { set } from '~data/actions/config';

import { Label, Checkbox, Button, Icon } from '~ui';

export default function SettingsAppRaindropsButtons() {
  const raindrops_buttons = useSelector(
    (state) => state.config.raindrops_buttons,
  );
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);

  //t.s() must run at render — a language switch remounts the screen, so
  //module-level labels would stay frozen in the import-time language
  const options = [
    ['select', t.s('select'), 'select_all'],
    ['current_tab', t.s('open'), 'click'],
    ['new_tab', t.s('openInNewTab'), 'open'],
    ['preview', t.s('preview'), 'show'],
    ['web', 'Web', 'web'],
    ['copy', t.s('copyLinkToClipboard'), 'duplicates'],
    ['ask', t.s('ask'), 'ai'],
    ['important', t.s('addToFavorites'), 'like'],
    ['tags', t.s('tags'), 'tag'],
    ['edit', t.s('edit'), 'edit'],
    ['remove', t.s('remove'), 'trash'],
  ];

  const getOption = (find) => options.find(([id]) => id == find) || [];

  const onToggleButton = (e) => {
    const id = e.currentTarget.name;
    const next = raindrops_buttons.includes(id)
      ? raindrops_buttons.filter((b) => b != id)
      : [...raindrops_buttons, id];

    dispatch(set('raindrops_buttons', next));
  };

  return (
    <>
      <Label>{t.s('buttons')}</Label>

      {show ? (
        <div>
          {options.map(([id, title, icon]) => {
            const checked = raindrops_buttons.includes(id);

            return (
              <Checkbox
                key={id}
                name={id}
                checked={checked}
                disabled={raindrops_buttons.length >= 5 && !checked}
                onChange={onToggleButton}
              >
                <Icon name={icon} />
                {title}
              </Checkbox>
            );
          })}
        </div>
      ) : (
        <div>
          <Button variant='outline' onClick={() => setShow(true)}>
            {raindrops_buttons.length ? (
              //icons
              raindrops_buttons.map((id) => (
                <Icon key={id} name={getOption(id)[2]} />
              ))
            ) : (
              //nothing selected
              <span>{t.s('hideAll')}</span>
            )}
            <Icon name='expand' size='micro' />
          </Button>
        </div>
      )}
    </>
  );
}
